export { default as DocumentUploadSolidIcon } from './DocumentUploadSolidIcon';
